import React from "react";

export function Icon(props) {
    return (
        <div className="icon-width px-0">
            <div className="text-center">
                <img className="jump-img" alt={props.name} src={props.url}/>
                <p className="mb-0 icon-text">{props.name}</p>
            </div>
        </div>
    );
}